import { render, staticRenderFns } from "./OnboardingChoose.vue?vue&type=template&id=d4f82838&scoped=true&"
import script from "./OnboardingChoose.vue?vue&type=script&lang=js&"
export * from "./OnboardingChoose.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingChoose.vue?vue&type=style&index=0&id=d4f82838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f82838",
  null
  
)

export default component.exports